module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "page-lock"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-body"
  }, [_c('div', {
    staticClass: "lock-head"
  }, [_vm._v(" System Maintenance")]), _vm._v(" "), _c('div', {
    staticClass: "lock-body maintenance-body"
  }, [_c('div', {
    staticClass: "lock-cont"
  }, [_c('div', {
    staticClass: "lock-item lock-item-full"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.maintenance_message)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-footer-custom"
  }, [_vm._v("© " + _vm._s(_vm.getCurrentYear) + " CaseMGR Solutions, Inc. All Rights Reserved.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-logo"
  }, [_c('a', {
    staticClass: "brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/pages/img/logo.png",
      "alt": "logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fb32ebe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Maintenance.vue
// module id = 1615
// module chunks = 1